import React from "react";

import {
	FormTab,
	TabbedForm,
	ReferenceInput,
	TextInput,
	SelectInput,
	useChoicesContext,
} from "react-admin";
import RichTextInput from "../../fields/RichTextInput";
import { SelectRubricTypeInput } from "../../fields/SelectRubricType";

const RubricCreatorSelectInput = (props) => {
	const { allChoices } = useChoicesContext(props);

	const choices = allChoices.map((v) => {
		// noinspection JSUnresolvedVariable
		return { id: v.id, name: `${v.firstname} ${v.lastname}` };
	});
	return <SelectInput {...props} source="user_id" choices={choices} />;
};

const RubricForm = (props) => (
	<TabbedForm {...props}>
		<FormTab label="Contenu">
			<TextInput fullWidth source="title" label="Titre" />
			<TextInput fullWidth source="subtitle" label="Sous-titre" />
			<RichTextInput source="content" label="Contenu visible" />
			<RichTextInput source="content_more" label="Contenu en savoir plus" />
		</FormTab>

		<FormTab label="Configuration">
			<TextInput fullWidth source="url" label="URL de la page" />
			<TextInput fullWidth source="meta_title" label="Titre pour le SEO" />
			<SelectRubricTypeInput source="type" label="Type de rubrique" />
			<ReferenceInput source="user_id" reference="user">
				<RubricCreatorSelectInput label="Créateur" />
				{/*<SelectInput optionText="id"/>*/}
			</ReferenceInput>
			<TextInput source="origin_code" label="Code origin" />
		</FormTab>
	</TabbedForm>
);

export default RubricForm;
